import { IGenericActionCreator } from "../../redux/actions.interface";

export class ContextManager {
    constructor(
        public actions: IGenericActionCreator,
        public fieldProp: string,
        public fieldTypeProp: string,
        public fieldIsRequired: boolean,
        public fieldType: string,
    ) { }

    public get stateProp(): string {
        return `${this.parentContext}::${this.fieldProp}`;
    }

    public get parentContext(): string {
        return `${this.actions.stateProp}`;
    }

    public get isOptionsField(): boolean {
        switch (this.fieldType) {
            case "dropdown":
            case "filteredDropdown":
            case "typeahead":
            case "radio":
            case "checkbox":
            case "multiselect":
                return true;
            default:
                return false;
        }
    }
}

export function initGenericFieldState(value, label, hint, placeholder?) {
    const state: any = {};
    state.value = value;
    state.label = label;
    state.hint = hint;
    if (placeholder !== undefined) {
        state.placeholder = placeholder;
    }
    return state;
}

export function initGenericOptionsFieldState(value, label, hint, options, placeholder?) {
    const state = initGenericFieldState(value, label, hint, placeholder);
    state.options = options;
    return state;
}

export function initGenericDropdownFieldState(value, label, hint, options, placeholder?) {
    const state = initGenericOptionsFieldState(value, label, hint, options, placeholder);
    state.selectedValue = undefined;
    state.selectedLabel = undefined;
    return state;
}
